import * as api from '../../api/api'

const state = {
  news: null,
  newpaged: null,
}

// mutations
const mutations = {
  saveHomeArticleList(state, data) {
    state.news = data.articles//新闻
    state.newpaged = data.paged
  },
}

// actions
const actions = {
  fetchHomeArticleList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      let params = {
        id: params.id,
        page: params.page,
        per_page: params.per_page
      }
      api.articleList(params).then(
        (response) => {
          if (response) {
            commit('saveHomeArticleList', response)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js